import React from 'react'

import WarningIcon from '@assets/icons/warningIcon.svg?react'

const ServiceEmergencyMessage = () => {
  return (
    <div className="flex items-center">
      <WarningIcon className="w-10 h-auto mr-2" />
      <div className="font-semibold text-gray-400">
        If this is an emergency, please call{' '}
        <a href="tel:7813747079" className="text-primary-blue hover:underline">(781)-374-7079</a> for immediate assistance.
      </div>
    </div>
  )
}

export default ServiceEmergencyMessage
